import React, { Fragment, useState } from "react"
import { useDispatch } from "react-redux"
import {
  Typography,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
  Input,
  FormHelperText,
  Checkbox,
  Box
} from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import MaskedMobileInput from "../../../../components/MaskedMobileInput"
import { Formik, Form } from "formik"
import Visibility from "@material-ui/icons/Visibility"
import VisibilityOff from "@material-ui/icons/VisibilityOff"
import * as Yup from "yup"
import API from "store/api"
import { setIsLoading } from "actions/isLoading"
import ReusableFormControl from "../../../../components/ReusableFormControl"
import { openSnackBar } from "actions/snack-bar"

const RegisterSchema = Yup.object().shape({
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  mobile: Yup.string()
    .required("Required")
    .length(14, "Please enter a mobile phone number"),
  password: Yup.string().required("Required"),
  confirmPassword: Yup.string()
    .oneOf(
      [Yup.ref("password"), null],
      "Confirm Password needs to match password."
    )
    .required("Password confirm is required")
})

const RegisterForm = ({ updateRegData, regData, classes, formRef }) => {
  const [showPassword, setShowPassword] = useState(false)
  const [checked, setChecked] = useState(false)
  const dispatch = useDispatch()
  const handleChange = event => {
    setChecked(event.target.checked)
  }

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  return (
    <Fragment>
      <Typography variant="h2" className={classes.registerTitle}>
        Register
      </Typography>
      {/* <Typography className={classes.registerExplanation}>
        Lorem ipsum dolor sit amet consectetur adipisicing elit.
      </Typography> */}
      <Formik
        innerRef={formRef}
        initialValues={{
          firstName: regData.firstName ? regData.firstName : "",
          lastName: regData.lastName ? regData.lastName : "",
          mobile: regData.mobile ? regData.mobile : "",
          password: regData.password ? regData.password : "",
          confirmPassword: ""
        }}
        validationSchema={RegisterSchema}
        onSubmit={(values, actions) => {
          if (checked) {
            dispatch(setIsLoading(true))
            actions.setStatus(undefined)
            API.get(`/users/phone/${values.mobile}`)
              .then(res => {
                if (!res.body.phoneNumberExists) {
                  dispatch(setIsLoading(false))
                  updateRegData(values)
                  setChecked(false)
                } else {
                  dispatch(setIsLoading(false))
                  actions.setStatus({
                    mobile: "Phone Number already in use."
                  })
                }
              })
              .catch(error => {
                console.log(error)
              })
          } else {
            dispatch(
              openSnackBar({ message: "Please, accept the Terms & Conditions" })
            )
          }
        }}
      >
        {formikProps => (
          <Form className={classes.form}>
            <ReusableFormControl
              name="firstName"
              label="First Name"
              formikProps={formikProps}
              inputLabelClass={classes.labelTextColor}
            />
            <ReusableFormControl
              name="lastName"
              label="Last Name"
              formikProps={formikProps}
              inputLabelClass={classes.labelTextColor}
            />
            <FormControl
              error={Boolean(
                (formikProps.errors.mobile && formikProps.touched.mobile) ||
                  (formikProps.status && formikProps.status.mobile)
              )}
            >
              <InputLabel htmlFor="mobile">
                <Typography variant="h5" className={classes.mobilLabel}>
                  Mobile
                </Typography>
              </InputLabel>
              <Input
                type="text"
                name="mobile"
                id="mobile"
                className={classes.hola}
                value={formikProps.values.mobile}
                onChange={e => {
                  formikProps.setStatus("")
                  formikProps.handleChange(e)
                }}
                onBlur={formikProps.handleBlur}
                inputComponent={MaskedMobileInput}
              />

              <FormHelperText>
                {(formikProps.touched.mobile && formikProps.errors.mobile) ||
                  (formikProps.status && formikProps.status.mobile)}
              </FormHelperText>
            </FormControl>
            <ReusableFormControl
              inputLabelClass={classes.labelTextColor}
              name="password"
              label="Password"
              formikProps={formikProps}
              inputProps={{
                type: showPassword ? "text" : "password",
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                    >
                      {showPassword ? (
                        <Visibility color="primary" />
                      ) : (
                        <VisibilityOff color="primary" />
                      )}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            <ReusableFormControl
              inputLabelClass={classes.labelTextColor}
              name="confirmPassword"
              label="Confirm Password"
              formikProps={formikProps}
              inputProps={{
                type: showPassword ? "text" : "password"
              }}
            />
            <Box
              display="flex"
              alignItems="center"
              className={classes.termsContainer}
            >
              <Checkbox
                className={classes.checkBox}
                checked={checked}
                onChange={handleChange}
                color="primary"
              />
              <Box display="flex" flexWrap="wrap">
                <Typography variant="body1" className={classes.AgreeAndText}>
                  I agree with
                </Typography>
                <a
                  href="https://firstlinesocial.com/terms-and-conditions"
                  target="_blanck"
                  className={classes.termsLinks}
                >
                  <Typography variant="body1">Terms and Conditions,</Typography>
                </a>
                <a
                  href="https://firstlinesocial.com/firstline-copyright"
                  target="_blanck"
                  className={classes.termsLinks}
                >
                  <Typography variant="body1">Copyright</Typography>
                </a>
                <Typography variant="body1" className={classes.AgreeAndText}>
                  and
                </Typography>
                <a
                  href="https://firstlinesocial.com/privacy-policy"
                  target="_blanck"
                  className={classes.termsLinks}
                >
                  <Typography variant="body1">Privacy Policy.</Typography>
                </a>
              </Box>
            </Box>
          </Form>
        )}
      </Formik>
    </Fragment>
  )
}

export default withStyles(styles)(RegisterForm)



// WEBPACK FOOTER //
// ./src/pages/Register/components/RegisterForm/index.jsx